/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_Child_LeaguesInputs */



/**
* | output |
* | --- |
* | "Child Leagues" |
*
* @param {League_Child_LeaguesInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_child_leagues = /** @type {((inputs?: League_Child_LeaguesInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_Child_LeaguesInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ligues enfants")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ligas hijas")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Ligas filhas")
	if (locale === "it") return /** @type {LocalizedString} */ ("Campionati figli")
	return /** @type {LocalizedString} */ ("Child Leagues")
});